module.exports = fox._r("fonts/montserrat-regular-webfont.ttf", __webpack_public_path__ + "fonts/T5JUwi_.ttf");


//////////////////
// WEBPACK FOOTER
// ./fonts/montserrat-regular-webfont.ttf
// module id = 28
// module chunks = 0